import axios from 'axios';

const eventActions = (dispatch) => {
  return {
    setEvent: (event) => {
      dispatch({ type: 'EVENT_SUCCESS', event: event });
    },
    loadEventDetail: (id, loadToken = true) => {
      dispatch({ type: 'EVENT_LOAD' });
      axios
        .get(`/api/visitor/events/${id}?loadToken=${loadToken}`, {})
        .then((response) => {
          if (response.data) {
            dispatch({ type: 'EVENT_SUCCESS', event: response.data });
          } else {
            dispatch({ type: 'EVENT_ERROR', error: 'Could not load event' });
          }
        })
        .catch((error) => {
          console.log('EVENT ERROR1', error);
          if (error.response.status === 403) {
            dispatch({ type: 'EVENT_NO_TICKET' });
          }
          dispatch({ type: 'EVENT_ERROR', error: 'Could not load event' });
        });
    },
    //This will load first event/session(by starttime) from Room
    loadEventDetailByRoomId: (roomid, loadToken = true) => {
      dispatch({ type: 'EVENT_LOAD' });
      axios
        .get(`/api/visitor/rooms/${roomid}`, {})
        .then((response) => {
          if (response.data) {
            const roomdata = response.data;
            //events is sorted by time
            if (roomdata.events.length <= 0) {
              dispatch({
                type: 'EVENT_ERROR',
                error: 'Could not load event',
              });
              return;
            }
            const eventId = roomdata.events[0].id;
            axios
              .get(`/api/visitor/events/${eventId}?loadToken=${loadToken}`, {})
              .then((response) => {
                if (response.data) {
                  dispatch({ type: 'EVENT_SUCCESS', event: response.data });
                } else {
                  dispatch({
                    type: 'EVENT_ERROR',
                    error: 'Could not load event',
                  });
                }
              })
              .catch((error) => {
                console.log('EVENT ERROR', error);
                if (error.response.status === 403) {
                  dispatch({ type: 'EVENT_NO_TICKET' });
                }
                dispatch({
                  type: 'EVENT_ERROR',
                  error: 'Could not load event',
                });
              });
          } else {
            dispatch({ type: 'EVENT_ERROR', error: 'Could not load event' });
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            dispatch({ type: 'EVENT_NO_TICKET' });
          }
          console.log('EVENT ERROR', error);
          dispatch({ type: 'EVENT_ERROR', error: 'Could not load event' });
        });
    },
  };
};
export default eventActions;
